import { z } from 'zod';

/** CRA inlines `REACT_APP_*` as strings; booleans come through as `"true"` / `"false"`. */
const envBooleanDefaultFalse = z.preprocess(val => {
  if (val === undefined || val === '') return false;
  if (typeof val === 'boolean') return val;
  if (val === 'true') return true;
  if (val === 'false') return false;
  return val;
}, z.boolean());

export const adminEnvSchema = z.object({
  REACT_APP_API_KEY: z.string().min(1),
  /** Auth0 tenant hostname (not a full URL). */
  REACT_APP_AUTH0_DOMAIN: z.string().min(1),
  REACT_APP_AUTH0_AUDIENCE_V2: z.string().min(1),
  REACT_APP_AUTH0_SCOPE_V2: z.string().min(1),
  REACT_APP_AUTH0_CLIENT_ID: z.string().min(1),
  REACT_APP_RECIPIENT_ADMIN: z.string().min(1),
  REACT_APP_SUPER_ADMIN: z.string().min(1),
  REACT_APP_PARTNER_ADMIN: z.string().min(1),
  REACT_APP_REFRESH_RBAC_LOCAL_STORAGE: envBooleanDefaultFalse,
  REACT_APP_MIXPANEL_PROJECT_TOKEN: z.string().optional(),
});

export type AdminEnv = z.infer<typeof adminEnvSchema>;

export function getAdminEnvInput(env: Record<string, string | undefined>) {
  return {
    REACT_APP_API_KEY: env.REACT_APP_API_KEY,
    REACT_APP_AUTH0_DOMAIN: env.REACT_APP_AUTH0_DOMAIN,
    REACT_APP_AUTH0_AUDIENCE_V2: env.REACT_APP_AUTH0_AUDIENCE_V2,
    REACT_APP_AUTH0_SCOPE_V2: env.REACT_APP_AUTH0_SCOPE_V2,
    REACT_APP_AUTH0_CLIENT_ID: env.REACT_APP_AUTH0_CLIENT_ID,
    REACT_APP_RECIPIENT_ADMIN: env.REACT_APP_RECIPIENT_ADMIN,
    REACT_APP_SUPER_ADMIN: env.REACT_APP_SUPER_ADMIN,
    REACT_APP_PARTNER_ADMIN: env.REACT_APP_PARTNER_ADMIN,
    REACT_APP_REFRESH_RBAC_LOCAL_STORAGE: env.REACT_APP_REFRESH_RBAC_LOCAL_STORAGE,
    REACT_APP_MIXPANEL_PROJECT_TOKEN: env.REACT_APP_MIXPANEL_PROJECT_TOKEN,
  };
}

export function safeParseAdminEnv(env: Record<string, string | undefined>) {
  return adminEnvSchema.safeParse(getAdminEnvInput(env));
}
